<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectTrader"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Promotor
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    traderList: {
      type: Array,
      default: [],
      required: true,
    },
  },
  data() {
    return {
      selectTrader: this.value,
      options: [],
    };
  },
  async mounted() {
    await this.handleGetPromoter();
  },
  methods: {
    async handleGetPromoter() {
      const uniqueNames = new Set(this.traderList);
      const listUniqueNames = Array.from(uniqueNames);

      listUniqueNames.sort((a, b) => {
        function extractFirstName(fullName) {
          return fullName.split(' ')[0];
        }

        const firstNameA = extractFirstName(a).toUpperCase();
        const firstNameB = extractFirstName(b).toUpperCase();

        if (firstNameA < firstNameB) return -1;
        if (firstNameA > firstNameB) return 1;
        return 0;
      });

      this.options = listUniqueNames.reduce((accum, item) => {
        if (item && item !== 'undefined' && item !== undefined) {
          let name = `${item[0].toUpperCase()}${item
            .substring(1)
            .toLowerCase()}`;
          return [
            ...accum,
            {
              value: item.trim(),
              text: name,
            },
          ];
        } else {
          return accum;
        }
      }, []);
    },
    handleChange() {
      this.$emit('input', this.selectTrader ? this.selectTrader.trim() : null);
    },
  },
};
</script>
